import { TextInput, VerticalFormField } from "components/common/wintForms";
import { BenefitNameViewProps } from "models/propTypes/benefitsPropTypes";
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { FC, useState } from "react";
import { TranslationKeys } from "translations";
import { isDeductionBenefitType } from "./useBenefitTypesHelper";

const BenefitName: FC<BenefitNameViewProps> = (props) => {
  const { connect, benefitTypeName, benefitTypeId } = props;

  const [benefitName, setBenefitName] = useState<string>("");

  const descriptionText = benefitName !== "" && benefitTypeName ? `${benefitTypeName} - ${benefitName}` : "";

  const nameConnector = connect("name");

  const onTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBenefitName(e.target.value);
    nameConnector.onChange(e);
  };

  return (
    <VerticalFormField<TextInputProps>
      Component={TextInput}
      {...nameConnector}
      label={
        isDeductionBenefitType(benefitTypeId)
          ? TranslationKeys.Benefit.DeductionNameLabel
          : TranslationKeys.Benefit.NameLabel
      }
      descriptionText={descriptionText}
      onChange={onTextInputChange}
    />
  );
};

export default BenefitName;
